import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "intelisoft_cookie_consent";

function applyConsent(status) {
  try {
    if (window.posthog) {
      if (status === "accepted") window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    }
  } catch (e) {
    /* posthog not available */
  }
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) {
      // No consent yet -> disable tracking until user decides
      applyConsent("declined");
      setVisible(true);
    } else {
      applyConsent(saved);
    }
  }, []);

  const choose = (status) => {
    localStorage.setItem(KEY, status);
    applyConsent(status);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[80] p-4 md:p-6">
      <div className="container mx-auto max-w-[1100px] bg-white rounded-2xl shadow-2xl border border-slate-100 p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-5">
        <div className="flex items-start gap-4 flex-1">
          <span
            className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0"
            style={{ background: "rgba(27,110,243,0.1)", color: "#1b6ef3" }}
          >
            <Cookie size={22} />
          </span>
          <p className="text-sm text-slate-600 leading-relaxed m-0">
            Wir verwenden Cookies und Analyse-Tools, um unsere Website zu verbessern.
            Sie können selbst entscheiden, ob Sie dies zulassen. Details in unserer{" "}
            <Link to="/legal/datenschutz" className="text-[#1b6ef3] font-medium underline">
              Datenschutzerklärung
            </Link>
            .
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={() => choose("declined")}
            className="px-5 py-2.5 rounded-full text-sm font-semibold text-slate-600 border border-slate-200 hover:bg-slate-50 transition-colors"
          >
            Ablehnen
          </button>
          <button onClick={() => choose("accepted")} className="btn-theme sm">
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
